import { useEffect, useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import { UseMotorRouting } from "./UseMotorRouting";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function OrderDetailsLog(props) {
  const [orderDetails, setOrderDetails] = useState();
  const { GetlocateLogesticId, EditLocation } = UseMotorRouting();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.open.show && props.open.model) {
      setOrderDetails(props.open.model);
    }
  }, [props.open]);

  return (
    <Box
      sx={{ mt: 2 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          value={orderDetails?.customer ?? ""}
          label="نام مشتری"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          value={orderDetails?.mobile ?? ""}
          label="موبایل"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          value={orderDetails?.driver ?? ""}
          label="راننده"
          multiline
          maxRows={3}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          value={orderDetails?.neighbourhood ?? ""}
          label="محله"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 10"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          value={orderDetails?.address ?? ""}
          label="آدرس"
          multiline
          maxRows={3}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 2"}>
        <TextField
          size="small"
          fullWidth
          id="outlined-basic"
          sx={{
            input: {
              textAlign: "center",
            },
          }}
          value={props.zoneIndex ?? ""}
          label="مسیر"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          justifyContent: "space-between",
        }}
        gridColumn="span 12"
      >
        <Button
          sx={{ width: "120px" }}
          variant="contained"
          color="secondary"
          onClick={() => {
            let model = {
              orderID: orderDetails.id,
            };
            GetlocateLogesticId(model, (callback) => {
              props.setSendNewLoc({
                ...props.sendNewLoc,
                latitude: callback.latitude,
                longitude: callback.longitude,
              });
            });
          }}
        >
          یافتن مختصات
        </Button>
        <Box>
          <Button
            sx={{ width: "80px", mr: 2 }}
            variant="contained"
            onClick={() => {
              EditLocation(props.sendNewLoc, () => props.callback());
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "80px" }}
            variant="outlined"
            onClick={() => {
              props.setOpen({ ...props.open, show: false });
            }}
          >
            انصراف
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
